import React, { Suspense } from "react";
import styled from "styled-components";

import { ReactComponent as ChatIcon } from "../../Assets/iconsv2/generic/messageIconEmpty.svg";

import { ReactComponent as VideoIcon } from "../../Assets/iconsv2/generic/Video.svg";
import { ReactComponent as CallIcon } from "../../Assets/iconsv2/generic/Phone.svg";

import { ReactComponent as ProIcon } from "../../Assets/iconsv2/generic/PremiumUser.svg";
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg";
import { ReactComponent as PlatformIconLight } from "../../Assets/iconsv2/generic/BusinessUserLight.svg";
import { ReactComponent as InviteContactIcon } from "../../Assets/iconsv2/generic/inviteContact.svg";
import { displayUserAvatar } from "../../Helpers/chatHelper/AvatarHelper";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const ContactElement = ({
    item,
    handleInvite,
    callAction,
    chatAction,
    style,
    containerClickAction,
}) => {
    const { theme } = useGenericComponentsStateService();
    let displayName = item.name;
    if (item.name === "") {
        displayName = item.phone_number;
    }

    return (
        <Warpper
            style={style}
            onClick={() => containerClickAction && containerClickAction(item)}
        >
            <FoundContact>
                <FoundContactAvatar>
                    {displayUserAvatar(item)}
                    {!handleInvite && (
                        <ProBadgeWrapper>
                            {item.is_pro_from_platform ? (
                                theme === "light" ? (
                                    <PlatformIconLight />
                                ) : (
                                    <PlatformIcon />
                                )
                            ) : (
                                item.is_pro && <ProIcon />
                            )}
                        </ProBadgeWrapper>
                    )}
                </FoundContactAvatar>
                <NameWrapper>
                    <ContactName>{displayName}</ContactName>
                </NameWrapper>
                {handleInvite && (
                    <InviteButton onClick={() => handleInvite(item)}>
                        <InviteContactIcon />
                    </InviteButton>
                )}
            </FoundContact>
            {(callAction || chatAction) && (
                <CallBtnWrapper>
                    {chatAction && (
                        <ChatIcon
                            onClick={(e) => {
                                e.stopPropagation();
                                chatAction(item);
                            }}
                        />
                    )}
                    {callAction && (
                        <VideoIcon
                            onClick={(e) => {
                                e.stopPropagation();
                                callAction(item, true);
                            }}
                        />
                    )}
                    {callAction && (
                        <CallIcon
                            onClick={(e) => {
                                e.stopPropagation();
                                callAction(item, false);
                            }}
                        />
                    )}
                </CallBtnWrapper>
            )}
        </Warpper>
    );
};

export default ContactElement;
const CallBtnWrapper = styled.div`
  display: none;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  svg {
    color: ${({ theme }) => theme.primaryButton.color};
    width: 20px;
    height: 20px;
  }
`;

const Warpper = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 16px;

  &:hover ${CallBtnWrapper} {
    display: flex;
  }
  &:hover {
    background: ${({ theme }) => theme.call.callElementSelectedBackground};
  }
`;

const FoundContact = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  width: 100%;
  position: relative;
  overflow:hidden;
  padding:13px 0;
`;

const ContactName = styled.p`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const FoundContactAvatar = styled.div`
  display: flex;
  height: 42px;
  width: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  max-height: 42px;
  border-radius: 100%;
  position: relative;

`;

const InviteButton = styled.button`
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: ${({ theme }) => theme.menu.selectedTextColor};
  cursor: pointer;
`;
const ProBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 20px;
  height: 16px;
  svg {
    color: ${({ theme }) => theme.loginButton.background};
  }
`;

const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;
